// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__F-veX","title":"ClientReferral_title__u0xpg","itemText":"ClientReferral_itemText__b6yAl"};